import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "This video was recorded in a forest north of Adis Ababa in Ethiopia. The sound comes from many cicadas. Though natural, the piercing tonal sound of these insects is quite loud (estimated at 70-75 dB(A)).",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "video",
            options: {
              src: `${config.ASSETS_URL}/02/29/principle/principle-1.mp4`,
            },
          },
          styles: {
            padding: "4% 4.6%",
          },
        },
      },
    },
  },
};

export default principle;
